import { useRecoilCallback } from 'recoil';
import {
    voiBoundsState,
    voiCheckboxState,
    voiConsumerRequestState,
} from '~/state/atoms/toolsAtoms';

/**
 * Drops the registration consumer's VOI box: unchecks it and clears the
 * shared bounds, unless another consumer (the body-contour region) owns
 * them. That box is drawn in the primary image's world space and stays
 * valid across a change of pair or of registration transform; cleared,
 * its panel would refill it with the full volume, turning an explicit
 * restriction into no restriction while its toggle stays checked.
 */
export function useDropRegistrationVoi(): () => void {
    return useRecoilCallback(
        ({ snapshot, set }) =>
            () => {
                set(voiCheckboxState, false);
                const request = snapshot
                    .getLoadable(voiConsumerRequestState)
                    .valueOrThrow();
                if (request === null) {
                    set(voiBoundsState, null);
                }
            },
        []
    );
}
